import React from 'react';
export function Footer() {
  return <footer className="px-4 md:px-8 py-12 bg-ink text-paper" data-id="element-38">
      <div className="max-w-7xl mx-auto" data-id="element-39">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-40">
          <div className="md:col-span-2" data-id="element-41">
            <h2 className="font-serif text-5xl font-black mb-6" data-id="element-42">קֶרֶן</h2>
            <p className="font-sans text-paper/70 max-w-sm" data-id="element-43">
              מגזין עצמאי לתרבות, מחשבה ורעיונות. מוקדש למילים שמעצבות את
              המציאות שלנו ולרעיונות שמרחיבים את גבולות המחשבה.
            </p>
          </div>

          <div data-id="element-44">
            <h4 className="font-sans font-bold text-paper mb-6 uppercase tracking-widest text-xs" data-id="element-45">
              מערכת
            </h4>
            <ul className="font-sans space-y-3 text-paper/70" data-id="element-46">
              <li data-id="element-47">
                <a href="#" className="hover:text-vermillion transition-colors" data-id="element-48">
                  אודות
                </a>
              </li>
              <li data-id="element-49">
                <a href="#" className="hover:text-vermillion transition-colors" data-id="element-50">
                  הכותבים שלנו
                </a>
              </li>
              <li data-id="element-51">
                <a href="#" className="hover:text-vermillion transition-colors" data-id="element-52">
                  הגשת חומרים
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="hover:text-vermillion transition-colors" data-id="element-54">
                  צור קשר
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-55">
            <h4 className="font-sans font-bold text-paper mb-6 uppercase tracking-widest text-xs" data-id="element-56">
              עקבו אחרינו
            </h4>
            <ul className="font-sans space-y-3 text-paper/70" data-id="element-57">
              <li data-id="element-58">
                <a href="#" className="hover:text-vermillion transition-colors" data-id="element-59">
                  אינסטגרם
                </a>
              </li>
              <li data-id="element-60">
                <a href="#" className="hover:text-vermillion transition-colors" data-id="element-61">
                  טוויטר
                </a>
              </li>
              <li data-id="element-62">
                <a href="#" className="hover:text-vermillion transition-colors" data-id="element-63">
                  פייסבוק
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="hover:text-vermillion transition-colors" data-id="element-65">
                  ניוזלטר
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-paper/20 flex flex-col md:flex-row justify-between items-center gap-4 font-sans text-xs text-paper/50" data-id="element-66">
          <div data-id="element-67">© 2026 קֶרֶן מגזין. כל הזכויות שמורות.</div>
          <div className="flex gap-6" data-id="element-68">
            <a href="#" className="hover:text-paper transition-colors" data-id="element-69">
              תנאי שימוש
            </a>
            <a href="#" className="hover:text-paper transition-colors" data-id="element-70">
              פרטיות
            </a>
            <a href="#" className="hover:text-paper transition-colors" data-id="element-71">
              נגישות
            </a>
          </div>
        </div>
      </div>
    </footer>;
}